export default __webpack_public_path__ + "static/media/SALAD-CHEDDAR.ee6ae1ee.png";